import { render } from "./PflegeNew.vue?vue&type=template&id=47c063e7"
import script from "./PflegeNew.vue?vue&type=script&lang=js"
export * from "./PflegeNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__